// AOS.init();

// Fancybox.bind('[data-fancybox="gallery"]', {
//     // Your custom options for a specific gallery
// });

$(document).ready(function(){
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 10) {
            $('.navbar').addClass('header-fixed');
            $(".cart-notification").addClass("adTop");
        }
        else {
            $('.navbar').removeClass('header-fixed');
            $(".cart-notification").removeClass("adTop")
        }
    });

    $(".SerachBtn").click(function() {  //use a class, since your ID gets mangled
        $('.Custom-SearchModal').addClass("active");      //add the class to the clicked element
        $('body').addClass("overflow");      //add the class to the clicked element
    });
    $(".CSM-close").click(function() {  //use a class, since your ID gets mangled
        $('.Custom-SearchModal').removeClass("active");      //add the class to the clicked element
        $('body').removeClass("overflow");      //add the class to the clicked element
    });

    $('#horizontalTab').easyResponsiveTabs({
        type: 'default', //Types: default, vertical, accordion
        width: 'auto', //auto or any width like 600px
        fit: true,   // 100% fit in a container
        closed: 'accordion', // Start closed if in accordion view
    });


// $('.banner-slider').owlCarousel({
//     loop: true,
//     margin: 10,
//     nav: true,
//     dots: true,
//     autoplay: false,
//     navText: ['<i class="fa-solid fa-angle-left"></i>','<i class="fa-solid fa-angle-right"></i>'],
//     autoplayTimeout: 8000,
//     autoplaySpeed: 2500,
//     smartSpeed: 2500,
//     animateOut: 'fadeOut',
//     animateIn: 'fadeIn',
//     autoplayHoverPause: false,
//     responsiveClass: true,
//     responsive:{
//         0:{
//             items: 1,
//         },
//         576:{
//             items: 1,
//         },
//         767:{
//             items: 1,
//         },
//         992:{
//             items: 1,
//         },
//         1200:{
//             items: 1,
//         },
//         1400:{
//             items: 1,
//         },
//         1600:{
//             items: 1,
//         },
//     }
// });

$(".banner-slider").on("initialized.owl.carousel changed.owl.carousel", function(e) {
    if (!e.namespace) {
        return;
    }
    $("#Bcounter").html(
        e.relatedTarget.relative(e.item.index) + 1 
        // + "<span>" + "/" + e.item.count + "</span>"
    );
}).owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    autoplay: false,
    navText: ['<i class="fa-solid fa-angle-left"></i>','<i class="fa-solid fa-angle-right"></i>'],
    autoplayTimeout: 8000,
    autoplaySpeed: 2500,
    smartSpeed: 2500,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    autoplayHoverPause: false,
    responsiveClass: true,
    responsive:{
        0:{
            items: 1,
        },
        576:{
            items: 1,
        },
        767:{
            items: 1,
        },
        992:{
            items: 1,
        },
        1200:{
            items: 1,
        },
        1400:{
            items: 1,
        },
        1600:{
            items: 1,
        },
    }
});

// banner slider js

// $('.Testi-Slider').owlCarousel({
//     loop: true,
//     margin: 24,
//     nav: true,
//     dots: false,
//     autoplay: true,
//     center: false,
//     navText: ['<i class="fa-solid fa-arrow-left"></i>','<i class="fa-solid fa-arrow-right"></i>'],
//     autoplayTimeout: 8000,
//     autoplaySpeed: 2500,
//     smartSpeed: 2500,
//     // animateOut: 'pulseOut',
//     // animateIn: 'pulseIn',
//     autoplayHoverPause: false,
//     responsiveClass: true,
//     responsive:{
//         0:{
//             items: 1,
//         },
//         580:{
//             items: 1,
//         },
//         767:{
//             items: 1,
//         },
//         992:{
//             items: 2,
//         },
//         1200:{
//             items: 2,
//         },
//         1400:{
//             items: 2,
//         },
//         1600:{
//             items: 2,
//         },
//     }
// });
$(".Testi-Slider").on("initialized.owl.carousel changed.owl.carousel", function(e) {
    if (!e.namespace) {
        return;
    }
    $("#counter").html(
        e.relatedTarget.relative(e.item.index) + 1 +"<span>" + "/" + "</span>" + "<span>" + e.item.count + "</span>"
    );
}).owlCarousel({
    loop: true,
    margin: 24,
    nav: true,
    dots: false,
    autoplay: true,
    navText: ['<i class="fa-solid fa-arrow-left"></i>','<i class="fa-solid fa-arrow-right"></i>'],
    autoplayTimeout: 8000,
    autoplaySpeed: 2500,
    smartSpeed: 2500,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    autoplayHoverPause: false,
    responsiveClass: true,
    responsive:{
        0:{
            items: 1,
        },
        580:{
            items: 1,
        },
        767:{
            items: 1,
        },
        992:{
            items: 2,
        },
        1200:{
            items: 2,
        },
        1400:{
            items: 2,
        },
        1600:{
            items: 2,
        },
    }
});

$('#TopNavHead-slider').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    //autoplaySpeed: 3000,
    autoplaySpeed: 0,
    infinite: true,
    speed: 9000,
    pauseOnHover: true,
    cssEase: 'linear',
    variableWidth: true,
    //draggable:false,
    //infinite: false,
    //speed: 300,
    centerMode: false,
    centerPadding: '30%',
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            //infinite: true,
            //dots: true
            }
        },
        {
            breakpoint: 767,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '5%',
            }
        },
        {
            breakpoint: 480,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '5%',
            }
        }

    ]
});





    // $('.category-ImgTxtArrow').on('click', function (e) {
    $('.category-ImgTxtArrow').on('click', function (e) {
        e.preventDefault();
        const $parent = $(this).parent();
        const isActive = $parent.hasClass('active');

        // Remove 'active' from all siblings
        $parent.siblings().removeClass('active');

        // Toggle 'active' only on the clicked one
        $parent.toggleClass('active', !isActive);
    });
  $('.header-top-slider').slick({
        variableWidth: true,
        infinite: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        cssEase: 'linear',
        arrows: false,
        dots: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        swipe: false,
        draggable: false,
        touchMove: false
    });



    $('.browseCate-slide').slick({
        slidesToShow:7,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        infinite: true,
        arrows: false,
        dots: false,
        pauseOnHover: true,   // Stop on hover
        pauseOnFocus: true,   // Stop when focused
        swipe: true,

        responsive: [
              {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5
                }
            },
               {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

   

    $('.new_arrival-slider').owlCarousel({
        loop: false,
        margin: 20,
        nav: false,
        dots: false,
        autoplay: false,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        smartSpeed: 800,
        swipe:false,

        responsive: {
            0: {
                items: 1.3
            },
            576: {
                items: 2
            },
            768: {
                items: 2.56
            },
            992: {
                items: 3
            },
            1200: {
                items: 4
            },
            1360: {
                items: 5
            }
        }
    });

        $('.review_slider').owlCarousel({
            item:3,
        loop: false,
        margin: 20,
        nav: false,
        dots: true,
        autoplay: false,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        smartSpeed: 800,
        swipe:false,

        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 1.25
            },
            768: {
                items: 2
            },
            992: {
                items: 2
            },
            1200: {
                items: 3
            },
            1360: {
                items: 3
            }
        }
    });

    $(function () {

        var endDate = $('#countdown').data('end');

        // Convert "2026-12-31 23:59:59"
        endDate = endDate.replace(' ', 'T');

        var target = new Date(endDate).getTime();

        function pad(n) {
            return n < 10 ? '0' + n : n;
        }

        var timer = setInterval(function () {

            var now = new Date().getTime();
            var distance = target - now;

            if (distance <= 0) {
                clearInterval(timer);

                $('#cd-days').text('00');
                $('#cd-hours').text('00');
                $('#cd-minutes').text('00');
                $('#cd-seconds').text('00');

                return;
            }

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            $('#cd-days').text(pad(days));
            $('#cd-hours').text(pad(hours));
            $('#cd-minutes').text(pad(minutes));
            $('#cd-seconds').text(pad(seconds));

        }, 1000);

    });


});


document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.facets__disclosure-vertical');

  accordions.forEach(function (accordion) {
    accordion.addEventListener('toggle', function () {
      if (this.open) {
        accordions.forEach(function (otherAccordion) {
          if (otherAccordion !== accordion) {
            otherAccordion.removeAttribute('open');
          }
        });
      }
    });
  });
});